import WithRender from "../../templates/base/upload.html";
import { mapGetters, mapActions } from "vuex";
import { i18n } from "../../i18n.js";

import vue2Dropzone from "vue2-dropzone";
import Loading from "vue-loading-overlay";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import axios from "../../axios-auth";
import qs from "qs";
import ProgressBar from "vue-progressbar-component";

export default WithRender({
  components: {
    vueDropzone: vue2Dropzone,
    Loading,
    ProgressBar
  },
  computed: {
    ...mapGetters([
      "getShowUpload",
      "getSelectionId",
      "getShowPreviewInUpload",
      "getIsPackingEnabled",
      "getIsPreflighPitstop",
      "getPitstopFileIsLoading",
      "getPitstopFileStatusResponse",
      "getTimer",
      "getUrl",
      "getSelectedOption",
      "getPreflightData",
      "getIsMyAccount",
      "getMyAccountUploadedFiles",
      "getToggleReadyToConnect",
      "getNumberOfPP",
      "getNumberOfUploads",
      "getMyAccountUploadPath",
      "getOrderItemId",
      "getDisableDeleteUploadAfterConnect"
    ]),
    refId: function () {
      return "dropzone_" + this.propsData.code;
    },
    showPitstopLoading: function () {
      if (this.getIsPreflighPitstop || this.uploadedFileHash) {
        return this.getPitstopFileIsLoading(this.uploadedFile);
      }
      return false;
    },
    showPitstopInfo: function () {
      if (this.getIsPreflighPitstop || this.uploadedFileHash) {
        var fileInfo = this.getPitstopFileStatusResponse(this.uploadedFile);
        if (!fileInfo) {
          return false;
        }

        if (fileInfo.status == "REQUEST_ERROR") {
          return [
            {
              isStatus: true,
              label: i18n.t("Preflight Status"),
              message: {
                [i18n.t("Status") + ":"]: i18n.t("Request error")
              }
            }
          ];
        }

        var info = [];
        // status
        info.push({
          isStatus: true,
          label: i18n.t("Preflight Status"),
          message: {
            [i18n.t("Status") + ":"]: fileInfo.status,
            [i18n.t("Errors") + ":"]: fileInfo.data.Errors,
            [i18n.t("Fixes") + ":"]: fileInfo.data.Fixed_errors,
            [i18n.t("Warnings") + ":"]: fileInfo.data.Warnings
          }
        });

        var updatedPreflight = this.getPreflightData(this.propsData.code);
        if (Object.keys(updatedPreflight).length > 0) {
          for (var item in updatedPreflight) {
            info.push(updatedPreflight[item]);
          }
          return info;
        }

        // info
        var preflightInfo = {};
        var anyPP = Object.keys(fileInfo.preflight)[0];
        for (var key in fileInfo.preflight[anyPP]) {
          var obj = fileInfo.preflight[anyPP][key];
          if (obj && typeof obj == "object") {
            info.push(obj);
          } else {
            preflightInfo[key] = fileInfo.preflight[anyPP][key];
          }
        }

        if (fileInfo.status == "FINALIZED") {
          return info;
        }

        this.setPreflightInfo({
          code: this.propsData.code,
          preflightInfo,
          request_finalized: true,
          uploadedFile: this.uploadedFile
        });
        return info;
      }
      return false;
    },
    preflightData: function () {
      return this.getPreflightData(this.propsData.code);
    },
    showDeleteButton: function () {
      return !this.getDisableDeleteUploadAfterConnect;
    }
  },
  methods: {
    ...mapActions([
      "setPreview3DImage",
      "pitstopAddFile",
      "pitstopDeleteFile",
      "uploadFile",
      "removeUploadedFile",
      "setPreflightInfo",
      "setFilesNeedToBeConnected",
      "uploadLoading",
      "setPreflightData",
      "removePreflightDataPP",
      "removePreflightInfoPP",
      "setPersonalizeLoading"
    ]),
    // this is appended to the url for the thumbnails of the uploaded artwork
    // to avoid the browser caching the image for subsequent uploads
    getUploadedFileUniqueVersion: function () {
      return Math.floor(Math.random() * 99999);
    },
    getAcceptedFiles: function () {
      var images = ["jpg", "jpeg", "gif", "png", "tif", "tiff"].map(el => {
        return "image/" + el;
      });
      var pdfVT = [".csv", ".xlsx", ".xls", ".zip"];
      return ["application/pdf"].concat(images);
    },
    afterComplete(file) {
      this.showPreflight = false;
      this.pitstopReport = false;
      this.isLoading = false;
      this.showRearrange = false;
      this.uploadedFileRelativePath = null;
      this.uploadLoading(false);
      this.setPersonalizeLoading(false);
      this.loadingProgress = 0;
      if (file.status == "error" && !file.accepted) {
        this.$swal({
          text: i18n.t("File is not in accepted format!"),
          icon: "warning"
        });
        return;
      }
      if (file.status == "success") {
        if (file.xhr.response) {
          var response = JSON.parse(file.xhr.response);
          if (response.success) {
            this.afterUploadFile(
              response.file_data[response.temp_filename],
              response.temp_filename,
              response.file_url
            );
          }
        }
      }
    },
    afterUploadFile: function (file_info, uploadedFile, file_url) {
      this.uploadFile();
      if (this.getIsMyAccount && this.getToggleReadyToConnect) {
        if (this.getNumberOfPP == this.getNumberOfUploads) {
          this.getToggleReadyToConnect(true);
        }
      }

      this.uploadedFile = uploadedFile;
      var pdfFile = false;
      if (file_info) {
        if (file_info.extension && file_info.extension == "PDF") {
          pdfFile = true;
          this.showRearrange = true;
          this.uploadedFileRelativePath = file_info.file;
          if (file_info.preflight) {
            this.showPreflight = true;
            var preflightKeys = Object.keys(file_info.preflight);
            var preflightData = [];
            var preflightInfo = {};
            for (var key of preflightKeys) {
              if (
                file_info.preflight[key] &&
                typeof file_info.preflight[key] == "object"
              ) {
                preflightData.push(file_info.preflight[key]);
              } else {
                preflightInfo[key] = file_info.preflight[key];
              }
            }
            this.setPreflightData({
              code: this.propsData.code,
              preflightData
            });
            this.setPreflightInfo({
              code: this.propsData.code,
              preflightInfo
            });
          } else if (this.getIsPreflighPitstop) {
            this.pitstopReport = true;
            this.uploadedFileHash = file_info.hash;
            this.pitstopAddFile({
              name: this.uploadedFile,
              hash: this.uploadedFileHash,
              product_part: this.propsData.code
            });
          }
          // set it to preflight row line object
        }
        if (this.getShowPreviewInUpload && file_info.preview) {
          this.previewFile = file_info.preview;
          if (file_info.preview_second) {
            this.previewFileSecond = file_info.preview_second;
          } else {
            this.previewFileSecond = "";
          }
          this.previewFileLink = this.previewFile;
          if (pdfFile) {
            this.previewFileLink =
              this.getUrl(axios.getPdfUploadPreview) +
              "?" +
              this.getFileParameters(file_info.file);
          }
          // checkf it it's an image. Then point directly to the main file
          if (["PNG", "JPG", "JPEG", "BMP"].includes(file_info.extension)) {
            this.previewFileLink = file_url;
          }
          this.fileUrl = file_url;
          const img = new Image();
          img.src = this.previewFile;
          img.onload = () => {
            this.previewUploaded = true;
          };
          this.statusUploaded = true;

          if (this.getIsPackingEnabled) {
            // put the preview in 3D
            this.setPreview3DImage([this.previewFile, this.previewFileSecond]);
          }
        } else {
          this.statusUploaded = true;
          this.fileUrl = file_url;
        }
      } else {
        this.error("", "Missing file data information", "");
      }
    },
    sendFile: function (file, xhr, formData) {
      this.isLoading = true;
      this.uploadLoading(true);
      this.prepareDropzoneInput();
      formData.append("id", this.propsData.code);
      formData.append("deleteOld", 1);
      if (this.getIsMyAccount && this.getMyAccountUploadPath) {
        formData.append("folder_name", this.getMyAccountUploadPath);
      } else {
        formData.append("folder_name", "tmp." + this.getSelectionId);
      }
      if (this.getIsPackingEnabled) {
        formData.append("packing", 1);
      }
      formData.append(
        "selected_pages",
        this.getSelectedOption({ pp: this.propsData.code, option: "pages" })
      );
      formData.append(
        "selected_format",
        this.getSelectedOption({ pp: this.propsData.code, option: "format" })
      );
      formData.append(
        "selected_paper",
        this.getSelectedOption({ pp: this.propsData.code, option: "paper" })
      );
      if (i18n.locale) {
        formData.append("lang", i18n.locale);
      }
    },
    drop: function (event) {
      if (event.dataTransfer && event.dataTransfer.files) {
        if (event.dataTransfer.files.length != 1) {
          this.$refs[this.refId].dropzone.multipleFilesError = true;
          this.$swal({
            text: i18n.t("Please upload just one file!"),
            icon: "warning"
          });

          return;
        }
      }

      this.isLoading = true;
      this.uploadLoading(true);
    },

    error: function (file, message, xhr) {
      this.isLoading = false;
      this.uploadLoading(false);
      this.setPersonalizeLoading(false);
      this.progrloadingProgressess = 0;
      this.showPreflight = false;
      this.pitstopReport = false;
      this.showRearrange = false;
      this.uploadedFileRelativePath = null;

      if (message && message.message) {
        this.$swal({
          text: message.message,
          icon: "error"
        });
      } else if (typeof message == "string") {
        this.$swal({
          text: message,
          icon: "error"
        });
      }
      this.$refs[this.refId].removeAllFiles();
    },

    fileAdded: function (file) {
      if (this.$refs[this.refId].dropzone.multipleFilesError) {
        this.$refs[this.refId].dropzone.removeFile(file);
      }
    },
    progress: function (file, progress, bytesSent) {
      if (progress == 100) {
        this.setPersonalizeLoading(true);
      }
      this.loadingProgress = progress;
    },

    onDelete: function () {
      if (!this.uploadedFile) {
        return;
      }
      this.statusUploaded = false;
      this.previewUploaded = false;
      this.previewFile = "";
      this.previewFileSecond = "";
      this.previewFileLink = "";
      this.$refs[this.refId].removeAllFiles();
      if (this.getIsPreflighPitstop && this.uploadedFileHash) {
        this.pitstopDeleteFile(this.uploadedFile);
      }
      if (this.getIsMyAccount && this.getToggleReadyToConnect) {
        this.getToggleReadyToConnect(false);
      }
      if (this.getIsPackingEnabled) {
        // reset the uploaded images for 3D
        this.setPreview3DImage([]);
      }

      this.removePreflightDataPP(this.propsData.code);
      this.removePreflightInfoPP(this.propsData.code);
      this.removeUploadedFile();
      this.setFilesNeedToBeConnected(true);

      var deleteParams = {
        selection_id: this.getSelectionId,
        filename: this.uploadedFile
      };
      if (this.getIsMyAccount && this.getOrderItemId) {
        deleteParams = {
          order_item: true,
          id: this.getOrderItemId,
          filename: this.uploadedFile
        };
      }

      axios.instance
        .post(
          this.$store.getters.getUrl(axios.deleteFile),
          qs.stringify(deleteParams)
        )
        .then(response => {
          if (!response.data.success) {
            console.log(response.data.message);
          }
          this.uploadedFile = null;
          this.uploadedFileHash = null;
        })
        .catch(error => {
          console.log(error);
        });
    },
    onDownload: function () {
      if (this.fileUrl) {
        window.open(this.fileUrl, "_blank");
      }
    },
    onPreview: function (event) {
      if (this.showRearrange) {
        window.fancyboxInstance = $.fancybox.open({
          src: this.previewFileLink,
          type: "iframe",
          width: "100%",
          height: "100%",
          iframe: {
            preload: true,
            css: {
              width: "100%",
              height: "100%",
              "max-width": "100%",
              "max-height": "100%"
            }
          },
          opts: {
            iframe: {
              preload: true,
              css: {
                width: "100%",
                height: "100%",
                "max-width": "100%",
                "max-height": "100%"
              }
            }
          }
        });
      } else {
        this.$refs[this.refId + "Img"].click();
      }
    },
    getFileParameters: function (fileName) {
      return (
        "path=" +
        fileName.match(/.*\//) +
        "&filename=" +
        fileName.replace(/.*\//, "")
      );
    },
    onRearrange: function (event) {
      if (this.uploadedFileRelativePath) {
        var url =
          this.getUrl(axios.rearrangePdf) +
          "?" +
          this.getFileParameters(this.uploadedFileRelativePath) +
          "&lang=" +
          i18n.locale;

        window.fancyboxInstance = $.fancybox.open({
          src: url,
          type: "iframe"
        });
      }
    },
    onViewReport: function (event) {
      var url =
        this.$store.getters.getUrl(axios.checkPreflight) +
        "?query=pdf_report&file=" +
        this.uploadedFileHash;

      window.fancyboxInstance = $.fancybox.open({
        src: url,
        type: "iframe"
      });
    },
    mounted: function () {
      this.prepareDropzoneInput();

      if (this.getIsMyAccount) {
        var uploadedFile = this.getMyAccountUploadedFiles(this.propsData.code);
        if (uploadedFile) {
          this.afterUploadFile(
            uploadedFile,
            uploadedFile.file,
            uploadedFile.original_file_name
          );
        }
      }
      if (this.getIsPackingEnabled) {
        window.document.addEventListener(
          "pqMatrix_paperChanged",
          this.onDelete
        );
      }

      window.document.addEventListener(
        "pqMatrix_onDisableUpload",
        this.onDelete
      );
    },
    prepareDropzoneInput() {
      var dropzone = this.$refs[this.refId].dropzone;
      dropzone.hiddenFileInput.removeAttribute("multiple");
      dropzone.multipleFilesError = false;
      dropzone.hiddenFileInput.addEventListener("click", function (event) {
        dropzone.multipleFilesError = false;
      });
    }
  },
  data: function () {
    return {
      dropzoneOptions: {
        url: this.$store.getters.getUrl(axios.apiUpload),
        maxFilesize: 100,
        dictDefaultMessage: i18n.t("Upload print file"),
        uploadMultiple: false,
        acceptedFiles: this.getAcceptedFiles().join(","),
        paramName: "qqfile",
        previewTemplate:
          '<div id="template-preview"><div class="dz-preview dz-file-preview well" id="dz-preview-template"><div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div></div></div>'
      },
      statusUploaded: false,
      previewUploaded: false,
      previewFile: "",
      previewFileSecond: "",
      previewFileLink: "",
      fileUrl: "",
      isLoading: false,
      loadingProgress: 0,
      showPreflight: false,
      uploadedFile: null,
      uploadedFileHash: null,
      uploadedFileRelativePath: null,
      pitstopReport: false,
      showRearrange: false,
      loading: {
        isLoading: true,
        fullPage: false,
        height: 100,
        width: 100
      }
    };
  },
  props: ["propsData", "alwaysShow"]
});
